import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Swipeable from 'react-swipeable'
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';

import MetaBox from './inputs/MetaBox'
import AudioPlayer from './Mui/AudioPlayer'
import ImagePreview from './Mui/ImagePreview'

import {
  get_question,
  question_audio,
  question_image,
  version_audio,
  version_image,
  version_media_request,
  reset_question,
  get_question_by_position
} from '../actions'
//
import {
  renderBody,
  capitalize,
} from '../helpers'

const styles = {
  root: {
    flexGrow: 1,
  },
  colorPrimary: {
    color: 'rgba(255,255,255,0)',
    backgroundColor: 'rgba(255,255,255,0)',
  },
  barColorPrimary: {
    color: 'rgba(255,255,255,0)',
    backgroundColor: 'rgba(255,255,255,0)',
  },
}

const mapStateToProps = state => {
  return {
    audio_source: state.question.audio_source,
    fetching_audio: state.question.fetching_audio,

    image_source: state.question.image_source,
    fetching_image: state.question.fetching_image,

    version_media: state.question.version_media,
    version_media2: state.question.version_media2,
    fetching_version_media: state.question.fetching_version_media,
    fetching_version_media2: state.question.fetching_version_media2,

    fetching: state.question.fetching_single,

    current_user: state.auth.current_user.data,
    question: state.question.question,
    fetched: state.question.fetched_single,
    questions: state.question.items,
    pagination: state.question.pagination,
    errors: state.question.errors,
    skip: state.question.skip
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getQuestion: question_id => dispatch( get_question(question_id) ),
    getAudio: (question_id) => dispatch( question_audio(question_id) ),
    versionAudio: (question_id, version_id) => dispatch( version_audio(question_id, version_id) ),
    getImage: (question_id) => dispatch( question_image(question_id) ),
    versionImage: (question_id, version_id, audio_with_image) => dispatch( version_image(question_id, version_id, audio_with_image) ),
    resetVersionMedia: () => dispatch( version_media_request() ),
    getPosition: (skip, filters, sort, order) => dispatch( get_question_by_position(skip, filters, sort, order) ),
    resetQuestion: () => dispatch( reset_question() )
  }
}

class ConnectedQuestionPreview extends React.Component {
  state = {
    loaded: false,
    skip: 0,
    total: 0,
    audio: 'nosource',
    image: 'nosource',
    file: '',
    file2: '', // in case of audio with image
    showBar: false,
    hideBar: true,
    question: {
      answers: []
    }
  }

  componentWillMount() {
    // this.props.resetQuestion()
  }

  handleNext() {
    this.props.getPosition(this.state.skip + 1, this.props.filters || {}, this.props.sort || '', this.props.order || '')
  }

  handlePrevious() {
    this.props.getPosition(this.state.skip - 1, this.props.filters || {}, this.props.sort || '', this.props.order || '')
  }

  handleKeyDown(e) {
    if (e.keyCode === 37) {
      this.handlePrevious()
    } else if (e.keyCode === 39 ) {
      this.handleNext()
    }
  }

  swipingLeft(e, absX) {
    this.handleNext()
  }

  swipingRight(e, absX) {
    this.handlePrevious()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.isopen) {
      return
    }

    if ((this.props.fetching || this.props.fetching_audio || this.props.fetching_audio || this.props.fetching_version_media) && this.state.showBar === false ) {
      this.setState({showBar: true, hideBar: false})
      setTimeout( function(self) {
        self.setState({hideBar: true})
      }, 1000, this)
    } else if (!this.props.fetching && !this.props.fetching_audio && !this.props.fetching_audio && !this.props.fetching_version_media && this.state.showBar) {
      this.setState({showBar: false})
    }

    if (this.props.preview) {
      // Triggered from TEMPLATE EDIT
      if (!this.state.loaded) {
        this.setState({loaded: true})
        return this.props.getPosition(0, this.props.filters || {}, this.props.order || '', this.props.sort || '')
      }
      if (this.props.fetched && !prevProps.fetched) {
        this.setState({question: this.props.question, total: this.props.question.total, skip: this.props.question.skip})
      }
    } else if (this.props.staticQuestion && this.props.isopen && !prevProps.isopen) {
      // Triggered from QUESTIONS EDIT (current_data)
      this.setState({question: this.props.staticQuestion})
    } else if (this.props.version && this.props.isopen && !prevProps.isopen) {
      // Triggered from QUESTIONS EDIT (version)
      this.setState({question: this.props.version})

    } else {
      // Triggered from QUESTIONS INDEX
      if (this.props.question_id !== prevProps.question_id && this.props.question_id !== '') {
        return this.props.getQuestion(this.props.question_id)
      }
      if (this.props.fetched && !prevProps.fetched) {
        const {page, per_page} = this.props.pagination
        this.setState({
          question: this.props.question,
          total: this.props.question.total === null ? this.props.pagination.total : this.props.question.total,
          skip: this.props.question.skip === null ?
            ((page - 1 ) * per_page ) + this.props.questions.findIndex( q => q.id === this.props.question.id ) :
            this.props.question.skip
        })
      }
    }

    if ( !this.props.staticQuestion && !this.props.version ) {

      if (  this.props.question.question_type === 'audio' &&
            this.props.question.audio_file !== null &&
            this.props.question.audio_file !== this.state.file) {
        this.setState({file: this.props.question.audio_file})
        this.props.getAudio(this.props.question.id, null)
      }

      if ( this.props.question.question_type === 'audio' &&
           this.props.question.image_file !== null &&
           this.props.question.image_file !== this.state.file2 ) {
        this.setState({file2: this.props.question.image_file})
        this.props.getImage(this.props.question.id, null)
      } else if ( this.props.question.question_type === 'audio' && !this.props.question.image_file && prevState.file2 ) {
        this.setState({file2: '', image: 'nosource'})
      }


      if ( prevProps.fetching_audio && !this.props.fetching_audio && this.props.audio_source !== null ) {
        this.setState( {audio: this.props.audio_source } )
      }

      if (  this.props.question.question_type === 'image' &&
            this.props.question.image_file !== null &&
            this.props.question.image_file !== this.state.file) {
        this.setState({file: this.props.question.image_file})
        this.props.getImage(this.props.question.id, null)
      }

      if ( prevProps.fetching_image && !this.props.fetching_image && this.props.image_source !== null ) {
        this.setState( {image: this.props.image_source } )
      }
    } else if ( this.props.version ) {
      const version_id = this.props.version ? this.props.version.id : null
      const question_id = this.props.question.id
      if (this.props.version.question_type === 'audio') {
        if ( !this.props.fetching_version_media && this.props.version.audio_file !== null && !this.props.version_media.media_source ) {
          this.props.versionAudio(question_id, version_id)
        } else if ( prevProps.fetching_version_media && !this.props.fetching_version_media && this.props.version_media.media_source ) {
          this.setState({audio: this.props.version_media.media_source})
        }
        if ( this.props.version.image_file !== null ) {
          if ( !this.props.fetching_version_media2 && this.props.version.image_file !== null && !this.props.version_media2.media_source ) {
            this.props.versionImage(question_id, version_id, true)
          } else if ( prevProps.fetching_version_media2 && !this.props.fetching_version_media2 && this.props.version_media2.media_source ) {
            this.setState({image: this.props.version_media2.media_source})
          }
        }

      } else if (this.props.version.question_type === 'image') {
        if ( !this.props.fetching_version_media && this.props.version.image_file !== null && !this.props.version_media.media_source ) {
          this.props.versionImage(question_id, version_id, false)
        } else if ( prevProps.fetching_version_media && !this.props.fetching_version_media && this.props.version_media.media_source ) {
          this.setState({image: this.props.version_media.media_source})
        }
      }
    }
  }

  render() {
    if ( !this.props.isopen ) {
      return ''
    }
    if ( !this.props.version && !this.props.staticQuestion && !this.props.question_id && !this.props.question) {
      return ''
    }

    const { id, answers, body, instructions, skill, competency, group_id } = this.state.question

    const {isopen, handleClose, resetVersionMedia, classes} = this.props
    const letters = ["A","B","C","D"]

    const showBody = body || ''
    const renderAnswers = answers || []

    if ( body === undefined || body === null || body.trim() === '' ) {
      return ''
    }

    const previewMode = !this.props.staticQuestion && !this.props.version
    const audio = this.props.staticQuestion ? this.props.staticQuestion.audio : this.state.audio
    const image = this.props.staticQuestion ? this.props.staticQuestion.image : this.state.image

    return (
      <Dialog
        className="dialog-wrapper"
        fullScreen={false}
        fullWidth={true}
        maxWidth={'md'}
        open={isopen}
        onKeyDown={this.handleKeyDown.bind(this)}
        onClose={e => {
          resetVersionMedia()
          handleClose()
        }}
      >
        <DialogContent className="dialog-content">
          <DialogTitle className="linear-progress-preview">
            {
              (this.state.showBar || !this.state.hideBar) ? (
                <LinearProgress />
              ) :   <LinearProgress classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }} />
            }
          </DialogTitle>
          <Swipeable
            onSwipingLeft={this.swipingLeft.bind(this)}
            onSwipingRight={this.swipingRight.bind(this)}>
            {
              previewMode && (
                <Grid container spacing={24} justify="center" className="c-black087 mb-40 body2" alignItems="center">

                  <Grid item>
                    <Link to ='' className="novisit" onClick={e=>{
                      e.preventDefault()
                      this.handlePrevious()
                    }}>Prev</Link>
                  </Grid>

                  <Grid item>
                    {this.state.skip + 1}/{this.state.total}
                  </Grid>

                  <Grid item>
                    <Link to ='' className="novisit" onClick={e=>{
                      e.preventDefault()
                      this.handleNext()
                    }}>Next</Link>
                  </Grid>

                </Grid>
              )
            }

            <Grid use="question data" container spacing={24} justify="space-around" className="mb-40">
              <Grid item xs={12} md={5}>

                <Typography className="body1 c-black087 mb-8 lh-28">INSTRUCTIONS</Typography>
                <Typography className="subtitle2 c-black087 mb-24 lh-24">{instructions || `Choose the correct answer (${answers !== undefined && answers !== null && answers.map( (ans,index) => letters[index]).join(', ')})`}</Typography>

                {
                  ((this.state.question.question_type === 'image' && image !== 'nosource' && !this.props.fetching_image && !this.props.fetching_version_media) ||
                   (this.state.question.question_type === 'audio' && image !== 'nosource' && !this.props.fetching_image && !this.props.fetching_version_media)) &&
                  (
                    <ImagePreview
                      source={image}
                      showDelete={false}
                    />
                  )
                }

                {
                  this.state.question.question_type === 'audio' && audio !== 'nosource' && !this.props.fetching_audio && !this.props.fetching_version_media &&
                  (
                    <div className="mb-24" style={{transform: "translateY(-24px)"}}>
                      <AudioPlayer
                        source={audio}
                        tempduration={this.state.tempduration}
                        showDelete={false}
                      />
                    </div>
                  )
                }

                <Typography className="body1 c-black087 mb-8 lh-28">QUESTION</Typography>

                <Typography className="subtitle2 c-black087 mb-24 lh-24 preline">
                  {renderBody(showBody)}
                </Typography>

                <Typography className="body1 c-black087 mb-4 lh-28">ANSWER</Typography>
                <Grid container>
                  <Grid>
                    {
                      renderAnswers.map( (ans, index) => {
                        const opacity = ans.right ? 1 : 0
                        return (
                          <Typography key={index} className="body2 c-black087 mb-8 lh-24 d-flex align-items-center">
                            <Icon className="c-black054" style={{marginRight: '8px', opacity: opacity}}>check_circle</Icon>
                            {letters[index]}. {ans.body}
                          </Typography>
                        )
                      })
                    }
                  </Grid>
                </Grid>

              </Grid>

              <Grid use="meta" item xs={12} md={5}>
                <Typography className="body1 c-black087 mb-8 lh-28">QUESTION SETTINGS</Typography>
                <MetaBox
                  title="Skill"
                  value={skill && skill.name}
                />
                <MetaBox
                  title="Competency"
                  value={competency && competency.name}
                />
                <MetaBox
                  title="CEFR Level"
                  value={ this.state.question.level.name || this.state.question.level.value || '' }
                />
                <MetaBox
                  title="Type"
                  value={capitalize(this.state.question.question_type)}
                />
                <MetaBox
                  title="Exp. Time"
                  value={this.state.question.seconds && `${this.state.question.seconds}s`}
                />
                <MetaBox
                  title="Sibling ID"
                  value={group_id}
                />

                {
                  previewMode && (
                    <React.Fragment>

                      <Divider className="bg-divider preview-divider" />

                      <Typography className="body1 c-black087 mb-8 lh-28">META</Typography>

                      <MetaBox
                        title="Status"
                        value={this.state.question.active ? 'Published ' : this.state.question.trash ? "In Trash " : "Draft "}
                      />

                      { (this.props.current_user.role === "admin" || this.props.current_user.role === "expert") && (
                          <MetaBox
                            title="Created by"
                            value={this.state.question.creator.display_name}
                          />
                        )
                      }

                      <MetaBox
                        title="Created on"
                        value={new Date(this.state.question.created_at).toLocaleString()}
                      />

                      {
                        this.props.question.modifier && (
                          <React.Fragment>
                            <MetaBox
                              title="Modified by"
                              value={this.props.question.modifier.display_name}
                            />

                            <MetaBox
                              title="Modified on"
                              value={new Date(this.props.question.updated_at).toLocaleString()}
                            />
                          </React.Fragment>
                        )
                      }

                      <MetaBox
                        title="ID"
                        value={id}
                      />

                    </React.Fragment>
                  )
                }

                {
                  this.state.question.tags && this.state.question.tags.length > 0 && (
                    <React.Fragment>
                      <Divider className="bg-divider preview-divider" />

                      <Typography className="body1 c-black087 mb-8 lh-28">TAGS</Typography>

                      <Grid container spacing={16} direction="column" justify="space-between" alignItems="flex-start">

                        {
                          this.state.question.tags.map( tag => {
                            return (
                              <Grid item key={tag.value}>
                                <Chip label={tag.label} style={{width: "120px", textAlign: 'left'}} />
                              </Grid>
                            )
                          })
                        }
                      </Grid>
                    </React.Fragment>
                  )
                }

              </Grid>
            </Grid>
            <Grid container spacing={24} justify="flex-end">
              {
                previewMode && !this.state.question.active && !this.state.question.trash && (
                  <Button className="buttonnoto c-blue" component={Link} to={`/questions/${id}/edit`} target="_blank">Edit</Button>
                )
              }

              <Button className="buttonnoto c-blue" onClick={this.props.handleClose}>Close</Button>

            </Grid>
          </Swipeable>
        </DialogContent>
      </Dialog>
    )
  }
}

const QuestionPreview = connect(mapStateToProps, mapDispatchToProps)(ConnectedQuestionPreview)

export default withStyles(styles)(QuestionPreview)



// WEBPACK FOOTER //
// ./src/js/components/QuestionPreview.js